import React, { FunctionComponent } from 'react';

import { RouteComponentProps } from '@reach/router';

import Loader from '@bitcoin-portal/verse-web-components/dist/Loader';

import { Wrapper } from './styled';

interface Props extends RouteComponentProps {
  [any: string]: unknown;
}
export const LoadingView: FunctionComponent<Props> = ({ ...rest }) => (
  <Wrapper {...rest}>
    <Loader />
  </Wrapper>
);

export default LoadingView;
